import * as React from 'react'
import { ValueComponentProps } from '../../../props'
import DocumentsQuestionViewModel from '../../DocumentsQuestionViewModel'
import { observer } from 'mobx-react'

export default observer(function DocumentsValue({
  vm,
}: ValueComponentProps<DocumentsQuestionViewModel>) {
  return <>{vm.toTextAnswer()}</>
})
